module.exports = "/images/moto.svg";